import {throttle} from "./throttle";

export function statsSection() {
  let
    breakpoint = 1024,
    win = $(window),
    slidesList = $(".stats-section");

  slidesList.find('.stats-item').each(function () {
    let item = $(this);

    item.addClass(item.find('b').text().length > 4 ? 'title-long' :'title-short');
  });

  function initSliders() {
    let winWidth = parseInt(win[0].innerWidth);

    slidesList.each(function () {
      let
        parent = $(this),
        slider = parent.find('.stats');


      if (slider.data('sliderData')) {
        if (winWidth >= breakpoint) {
          slider.data('sliderData').slick('unslick');
          slider.data('sliderData', null);
        }

      } else if (winWidth < breakpoint) {
        slider.data('sliderData',(slider.slick({
            fade: true,
            infinite: true,
            mobileFirst: true,
            adaptiveHeight:true,
            prevArrow: '<button type="button" class="slick-arrow slick-prev">&lt;&lt; prev</button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next">next &gt;&gt;</button>',
            appendArrows: parent.find('.stats-nav'),
          })));

      }
    });
  }

  win.on("load", function () {
    initSliders();

  }).on("resize", throttle(function () {
    initSliders();

  }, 405)).on("orientationchange", throttle(function () {
    initSliders();

  }, 405));
}


// WEBPACK FOOTER //
// ./assets/js/modules/statsSection.js